import React from 'react';

import {View, Text, Svg, Path} from '@react-pdf/renderer';

import {cultureFitStyles as styles} from './styles/culture-fit-styles';
import {sharedStyles} from './styles/shared-styles';

interface Props {
  percentage: number;
  text: string;
}

export const ReportCultureFit: React.FC<Props> = ({percentage, text}: Props) => {
  const normalizedPercentage = Math.min(Math.max(percentage, 0), 100);
  const truncatedPercentage = Math.trunc(normalizedPercentage);

  const size = 32;
  const strokeWidth = 4;
  const radius = (size - strokeWidth) / 2;

  const filledColor = '#D05129';

  const circlePath = `
    M ${size / 2}, ${size / 2}
    m 0, -${radius}
    a ${radius},${radius} 0 1,1 0,${2 * radius}
    a ${radius},${radius} 0 1,1 0,-${2 * radius}
  `;

  const arcPath = (percentage: number) => {
    const endAngle = (percentage / 100) * 360;
    const largeArcFlag = endAngle > 180 ? 1 : 0;
    const x = size / 2 + radius * Math.cos((endAngle - 90) * (Math.PI / 180));
    const y = size / 2 + radius * Math.sin((endAngle - 90) * (Math.PI / 180));
    return `
      M ${size / 2}, ${size / 2}
      L ${size / 2}, ${size / 2 - radius}
      A ${radius},${radius} 0 ${largeArcFlag},1 ${x},${y}
      Z
    `;
  };

  return (
    <View style={styles.container}>
      <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <Path d={circlePath} stroke={filledColor} strokeOpacity={0.24} strokeWidth={strokeWidth} fill='none' />
        <Path d={arcPath(truncatedPercentage)} fill={filledColor} />
      </Svg>
      <Text style={{...sharedStyles.h2, marginHorizontal: 4, fontWeight: 'bold'}}>{`${truncatedPercentage}%`}</Text>
      <Text style={sharedStyles.h3}>{text}</Text>
    </View>
  );
};
